import axios from "axios"
import React from "react"
import Head from 'next/head'
import TestimonialHeader from "../components/Testimonials/TestimonialHeader"
import Testimonials from "../components/Testimonials/Testimonials"
import config from '../config/config'
import seo from "../config/seo"
import FooterComp from '../components/Footer/Footer'
import HeaderComp from '../components/Header/Header'
import SetHeaders from "../config/SetHeaders"

const TestimonialContainer = ({ Header, Body, Footer, response, showLoader, hideLoader }: any) => {

  const components = (typeName: any, compData: any, key: any) => {
    switch (typeName) {
      case 'connect.page-heading-widget':
        return <TestimonialHeader key={key} data={compData} />;
      case 'testimonial.testimonial-section':
        return <Testimonials key={key} data={compData} />;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {response && !response.Seo && (
        <Head>
          <title>{seo.testimonial}</title>
        </Head>
      )}
      {response && <SetHeaders HEADERS={response} />}
      {Header && <HeaderComp HeaderValue={Header} />}
      <div className="app-body">
        {Body &&
          Body.map((data: any, i: number) => {
            return components(data.__component, data, i);
          })}
      </div>
      {Footer && <FooterComp data={Footer} />}
    </React.Fragment>
  );
}

export async function getStaticProps() {
  const { data } = await axios.get(config.endpoints.testimonials)
  return {
    props: {
      Header: data.Header,
      Body: data.Body,
      Footer: data.Footer.Footer,
      resource: data
    },
    revalidate: 3600
  }
}

export default TestimonialContainer